/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMap, useMapEvent, useMapEvents } from 'react-leaflet';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from '../../../../features/notificationSlice';

const MapRefComponent = (props) => {
  const {
    searchResult,
    handleAddMarker,
    setCenter,
    setEndMarkerPosition,
    setStartMarkerPosition,
    setCurrentZoomLevel,
    isDisplayTrafficStatus,
    setCurrentBounds,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const map = useMap();
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const { coords } = position;
      const { latitude, longitude } = coords;
      setCenter([latitude, longitude]);
      map.setView({ lat: latitude, lng: longitude });
    });
    setCurrentBounds(map.getBounds());
  }, []);
  useEffect(() => {
    if (searchResult.position) {
      map.flyTo(searchResult.position);
      //reset end position when search success
      setEndMarkerPosition({});
      setStartMarkerPosition({});
    }
  }, [searchResult]);

  //map click event
  useMapEvent('click', (e) => {
    if (isDisplayTrafficStatus) {
      dispatch(
        enqueueSnackbar({
          message: t('ErrorChangeMode'),
          options: {
            variant: 'error',
          },
        })
      );
      return;
    }
    handleAddMarker(e.latlng);
  });
  useMapEvents({
    moveend: (e) => {
      const zoomLevel = map.getZoom();
      setCurrentZoomLevel(zoomLevel);
      setCurrentBounds(map.getBounds());
    },
  });
  return null;
};

export default MapRefComponent;
